<h2 class="titleColor">
    {{ 'cargaMasivaProductos.titulocargaMasiva' | translate }}
</h2>

<!-- Formulario reactivo con FormControl para el tipo de producto -->
<form [formGroup]="formulario">
    <label class="titleProducto" for="tipoProducto" style="font-weight: bold">
        Tipo de producto:
    </label>
    <select id="tipoProducto" formControlName="tipoProducto">
        <option *ngFor="let producto of tiposProducto" [value]="producto.id">
            {{ producto.nombre }}
        </option>
    </select>
</form>

<app-table-carga-masiva
    [columnas]="columnas"
    [tipoProducto]="
        formulario.get('tipoProducto').value
    "></app-table-carga-masiva>

<router-outlet></router-outlet>
